export default __webpack_public_path__ + "static/media/partners-bg.8f5ea086.jpg";